<!-- 辅导信息导航 -->
<template>
  <div class="project-coach-info-menu">
    <ul>
      <!-- class="active"  -->
      <li v-for="(item,index) in menuList"
          :key="index"
          :class="[$route.matched.some(({name}) => item.name.includes(name))?'active':'']">
        <a @click="routerHandle(item.name[0])">{{item.title}}</a>
        <div class="slash"
             v-show="index !== menuList.length-1">/</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'project-coach-info-menu',
  components: {},
  data () {
    return {
      menuList: [
        {
          title: '文书信息',
          name: ['project-essay-info']
        },
        {
          title: '文书修改',
          name: ['project-essay-modify']
        },
        {
          title: '面试相关',
          name: ['project-interview', 'project-interview-exp', 'project-interview-zoom', 'project-interview-mentor']
        },
        {
          title: '申请情况',
          name: ['project-application-status']
        }
      ]
    }
  },
  computed: {
    ...mapState({
      'userInfo': (state) => state.user.userInfo
    }),
    expertCount () {
      return this.userInfo.packageInfo && this.userInfo.packageInfo.expertCount
    }
  },
  mounted () {
    this.setMenu()
  },
  methods: {
    routerHandle (name) {
      this.$router.push({
        name
      })
    },
    setMenu () {
      let expertCount = this.expertCount
      let experrMenu = {
        title: '专家修改',
        name: ['project-expert-modify']
      }
      // 判断是否有专家修改的权限
      if (expertCount > 0 && this.menuList.findIndex(item => item.title === '专家修改') === -1) {
        this.menuList.splice(1, 0, experrMenu)
      }
    }
  },
  watch: {
    userInfo (newValue) {
      this.setMenu()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
